import request from "@/lib/request.js";

const state = {
  unReadMsgNum: 0, //未读通知数量
  badgeHidden: true //通知数量标记是否展示
};

const mutations = {
  SET_UNREADNOTICE_NUM: (state, num) => {
    state.unReadMsgNum = num;
  },
  SET_BADGEHIDDEN: (state, status) => {
    state.badgeHidden = status;
  }
};

const actions = {
  //获取未读通知数量
  getUnReadNoticeNum({ commit, state }) {
    return new Promise((resolve, reject) => {
      request
        .get("/tenantMessage/getUnreadMessageCnt", {})
        .then(res => {
          if (res.status == 200 && res.data.code == 200) {
            if (res.data.data == 0) {
              commit("SET_BADGEHIDDEN", true);
            } else {
              commit("SET_UNREADNOTICE_NUM", res.data.data);
              commit("SET_BADGEHIDDEN", false);
            }
            resolve(res);
          } else {
            reject(res.data.msg);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/app.js